<template>
  <div>
    <div
      v-for="field in fields"
      :key="field.id"
      class="mb-3 flex items-center text-sm"
    >
      <div class="flex w-[60%] items-center pe-2 font-medium">
        <lucide-icon
          v-if="field.icon"
          class="me-2 pb-1 text-gray-600 dark:text-neutral-400"
          :icon="field.icon"
          :size="30"
        />
        <template v-if="field.translated_name">
          {{ field.translated_name }}
        </template>
        <template v-else> {{ $t(`fields.names.${field.name}`) }}: </template>
      </div>
      <div class="w-[40%] text-end">
        <template v-if="field.format === 'number' || field.format === 'text'">
          {{ field.value }}
        </template>
        <template v-if="field.format === 'area'">
          {{ $formatNumber(field.value) }}
          <span v-html="$t('labels.square area.' + areaUnit)"></span>
        </template>
        <template v-else-if="field.format === 'translate'">
          {{ $t(`fields.${field.name}.${field.value}`) }}
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'InstanceFields',
  props: {
    fields: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {};
  },
  computed: {
    ...mapGetters(['project']),
    areaUnit() {
      return this.project.area_unit;
    },
  },
  methods: {},
};
</script>
